import React from 'react';
import Modal from '../../styled-base/modal';
import UserDetailsPopup from '../../components/popup/userDetailsPopup';

const UserInfoModal = ({item, boardInfo, onClose}: any) => {

    return (
        <Modal width={750} classes='portal-modal-user-info'>
            <Modal.Content>
                <UserDetailsPopup
                    item={item}
                    userId={item.id}
                    boardDetails={boardInfo}
                    onClose={onClose}
                />
            </Modal.Content>
        </Modal>
    )
}

export default UserInfoModal;